<template>
    <div class="kyc-full-risk-evaluation">
        <el-tree
            :data="treeData"
        />
    </div>
</template>

<script>
export default {
    name: 'kycRiskEvaluationTree',

    props: {
        data: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            treeData: [],
            // data: [
            //     {
            //         sub_scores: {
            //             browser: 6.6,
            //             country: 1,
            //             email_address: 1,
            //             email_tenure: 1,
            //             ip_tenure: 1,
            //             time_of_day: 1
            //         },
            //         email_factors: {
            //             domain: { first_seen: '2019-08-03' },
            //             first_seen: '2023-10-18',
            //             is_disposable: false,
            //             is_free: false,
            //             is_high_risk: false
            //         },
            //         email_risky: 0,
            //         ip_address_factors: {
            //             risk: 0.59,
            //             risk_reasons: [
            //                 {
            //                     code: 'MINFRAUD_NETWORK_ACTIVITY',
            //                     reason: 'Suspicious activity has been seen on this IP address across minFraud customers.'
            //                 }
            //             ],
            //             country: {
            //                 is_high_risk: false,
            //                 confidence: 90,
            //                 iso_code: 'GT',
            //                 geoname_id: 3595528,
            //                 names: {
            //                     ja: '\u30b0\u30a2\u30c6\u30de\u30e9',
            //                     'pt-BR': 'Guatemala',
            //                     ru: '\u0413\u0432\u0430\u0442\u0435\u043c\u0430\u043b\u0430',
            //                     'zh-CN': '\u5371\u5730\u9a6c\u62c9',
            //                     de: 'Guatemala',
            //                     en: 'Guatemala',
            //                     es: 'Guatemala',
            //                     fr: 'Guatemala'
            //                 }
            //             },
            //             location: {
            //                 local_time: '2023-10-19T14:42:46-06:00',
            //                 accuracy_radius: 50,
            //                 latitude: 14.6343,
            //                 longitude: -90.5155,
            //                 time_zone: 'America/Guatemala'
            //             },
            //             city: {
            //                 confidence: 90,
            //                 geoname_id: 3598132,
            //                 names: {
            //                     de: 'Guatemala-Stadt',
            //                     en: 'Guatemala City',
            //                     es: 'Guate',
            //                     fr: 'Guatemala',
            //                     ja: '\u30b0\u30a2\u30c6\u30de\u30e9\u30b7\u30c6\u30a3',
            //                     'pt-BR': 'Cidade da Guatemala',
            //                     ru: '\u0413\u0432\u0430\u0442\u0435\u043c\u0430\u043b\u0430'
            //                 }
            //             },
            //             continent: {
            //                 code: 'NA',
            //                 geoname_id: 6255149,
            //                 names: {
            //                     de: 'Nordamerika',
            //                     en: 'North America',
            //                     es: 'Norteam\u00e9rica',
            //                     fr: 'Am\u00e9rique du Nord',
            //                     ja: '\u5317\u30a2\u30e1\u30ea\u30ab',
            //                     'pt-BR': 'Am\u00e9rica do Norte',
            //                     ru: '\u0421\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u0410\u043c\u0435\u0440\u0438\u043a\u0430',
            //                     'zh-CN': '\u5317\u7f8e\u6d32'
            //                 }
            //             },
            //             postal: { confidence: 10, code: '01001' },
            //             registered_country: {
            //                 iso_code: 'GT',
            //                 geoname_id: 3595528,
            //                 names: {
            //                     ru: '\u0413\u0432\u0430\u0442\u0435\u043c\u0430\u043b\u0430',
            //                     'zh-CN': '\u5371\u5730\u9a6c\u62c9',
            //                     de: 'Guatemala',
            //                     en: 'Guatemala',
            //                     es: 'Guatemala',
            //                     fr: 'Guatemala',
            //                     ja: '\u30b0\u30a2\u30c6\u30de\u30e9',
            //                     'pt-BR': 'Guatemala'
            //                 }
            //             },
            //             subdivisions: [
            //                 {
            //                     confidence: 90,
            //                     iso_code: 'GU',
            //                     geoname_id: 3595530,
            //                     names: { en: 'Guatemala' }
            //                 }
            //             ],
            //             traits: {
            //                 static_ip_score: 16.1,
            //                 user_count: 5,
            //                 user_type: 'traveler',
            //                 autonomous_system_number: 52362,
            //                 autonomous_system_organization:
            //                     'Servicios Innovadores de Comunicacion y Entretenimiento, S.A.',
            //                 isp: 'Tigo Guatemala',
            //                 organization: 'Tigo Guatemala',
            //                 ip_address: '190.104.114.191',
            //                 network: '190.104.114.191/32'
            //             }
            //         },
            //         warnings: [
            //             'The mailbox is undeliverable or does not exist.'
            //         ],
            //         raw_factors: {
            //             subscores: {
            //                 browser: 6.98,
            //                 chargeback: 21.52,
            //                 country: 1,
            //                 email_address: 0.18,
            //                 email_domain: 1,
            //                 email_tenure: 1,
            //                 ip_tenure: 1,
            //                 time_of_day: 1
            //             },
            //             ip_address: {
            //                 risk: 60,
            //                 risk_reasons: [
            //                     {
            //                         code: 'ANONYMOUS_IP',
            //                         reason: 'The IP address belongs to an anonymous network. See /ip_address/traits for more details.'
            //                     },
            //                     {
            //                         code: 'EMAIL_VELOCITY',
            //                         reason: 'Many different email addresses have been seen on this IP address.'
            //                     }
            //                 ],
            //                 country: {
            //                     is_high_risk: false,
            //                     confidence: 99,
            //                     iso_code: 'US',
            //                     geoname_id: 6252001,
            //                     names: {
            //                         ja: '\u30a2\u30e1\u30ea\u30ab',
            //                         'pt-BR': 'EUA',
            //                         ru: '\u0421\u0428\u0410',
            //                         'zh-CN': '\u7f8e\u56fd',
            //                         de: 'Vereinigte Staaten',
            //                         en: 'United States',
            //                         es: 'Estados Unidos',
            //                         fr: '\u00c9tats Unis'
            //                     }
            //                 },
            //                 location: {
            //                     local_time: '2023-10-18T13:01:14-05:00',
            //                     average_income: 25637,
            //                     population_density: 870,
            //                     accuracy_radius: 1000,
            //                     latitude: 37.751,
            //                     longitude: -97.822,
            //                     time_zone: 'America/Chicago'
            //                 },
            //                 continent: {
            //                     code: 'NA',
            //                     geoname_id: 6255149,
            //                     names: {
            //                         ru: '\u0421\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u0410\u043c\u0435\u0440\u0438\u043a\u0430',
            //                         'zh-CN': '\u5317\u7f8e\u6d32',
            //                         de: 'Nordamerika',
            //                         en: 'North America',
            //                         es: 'Norteam\u00e9rica',
            //                         fr: 'Am\u00e9rique du Nord',
            //                         ja: '\u5317\u30a2\u30e1\u30ea\u30ab',
            //                         'pt-BR': 'Am\u00e9rica do Norte'
            //                     }
            //                 },
            //                 registered_country: {
            //                     is_in_european_union: true,
            //                     iso_code: 'CZ',
            //                     geoname_id: 3077311,
            //                     names: {
            //                         'zh-CN': '\u6377\u514b',
            //                         de: 'Tschechien',
            //                         en: 'Czechia',
            //                         es: 'Chequia',
            //                         fr: 'Tch\u00e9quie',
            //                         ja: '\u30c1\u30a7\u30b3\u5171\u548c\u56fd',
            //                         'pt-BR': 'Ch\u00e9quia',
            //                         ru: '\u0427\u0435\u0445\u0438\u044f'
            //                     }
            //                 },
            //                 traits: {
            //                     is_anonymous: true,
            //                     is_hosting_provider: true,
            //                     user_count: 13,
            //                     user_type: 'hosting',
            //                     autonomous_system_number: 60068,
            //                     autonomous_system_organization:
            //                         'Datacamp Limited',
            //                     domain: 'cdn77.com',
            //                     isp: 'Datacamp Limited',
            //                     organization: 'Datacamp Limited',
            //                     ip_address: '89.187.170.169',
            //                     network: '89.187.170.169/32'
            //                 }
            //             },
            //             email: {
            //                 domain: { first_seen: '2019-01-18' },
            //                 first_seen: '2023-10-18',
            //                 is_disposable: false,
            //                 is_free: false,
            //                 is_high_risk: false
            //             },
            //             id: '3d6ce9d6-aab7-496d-9ac4-33a3ae98956f',
            //             risk_score: 52.81,
            //             funds_remaining: 1.745,
            //             queries_remaining: 87
            //         },
            //         risk_score: 52.81
            //     }
            // ]
        }
    },

    methods: {
        transformToTree(data) {
            const result = []

            // return the node with a parent
            // data.forEach(item => {
            //     const node = {
            //         label: 'Full risk evaluation report',
            //         children: []
            //     };

            //     for (const key in item) {
            //         node.children.push(this.parseItem(key, item[key]));
            //     }

            //     result.push(node);
            // });

            // return the children nodes without a parent
            data.forEach((item) => {
                for (const key in item) {
                    result.push(this.parseItem(key, item[key]))
                }
            })

            return result
        },

        parseItem(key, value) {
            if (typeof value === 'object' && value !== null) {
                if (Array.isArray(value)) {
                    return {
                        label: key,
                        children: value.map((item, index) => this.parseItem(index, item))
                    }
                } else {
                    const children = []

                    for (const k in value) {
                        children.push(this.parseItem(k, value[k]))
                    }

                    return {
                        label: key,
                        children: children
                    }
                }
            } else {
                return {
                    label: `${key}: ${value}`
                }
            }
        }
    },

    created () {
        this.treeData = this.transformToTree(this.data)
    }
}
</script>
